export default "/_next/static/images/2020-1x-20c91a8d2d6e7f4ee64b25d2fc3a79ed.png";